import React, { Component } from 'react'
import { connect } from 'react-redux'
import { array, string, bool } from 'prop-types'
import { zip } from 'lodash'
import ListItemMap from './ListItemMap'
import { toggleSubTypeMenu } from '../../../../store/Actions/UiActions'
import { filterSignsBySub } from '../../../../store/Actions'
import { updateClusterColor } from '../../../../store/Actions/MapActions'
import './styles/SubTypeMenu.css'
import { Segment, List } from 'semantic-ui-react'

const subtypeStyle = {
  position: 'absolute',
  listStyle: 'none',
  backgroundColor: 'white',
  zIndex: 10001,
  top: '25%',
  left: '20%',
}

class SubTypeMenu extends Component {
  handleFilter = () => {
    this.props.filterSignsBySub('')
    this.props.updateClusterColor(null)
    this.props.toggleSubTypeMenu(false)
  }
  render() {
    const { showSubTypeMenu, subtypes, theme, toggleSubTypeMenu } = this.props
    if (showSubTypeMenu) {
      return (
        <Segment.Group
          raised
          style={subtypeStyle}
          onMouseLeave={() => toggleSubTypeMenu(false)}
        >
          <Segment style={{ padding: '2px' }}>
            <List selection divided verticalAlign="middle">
              <ListItemMap subtypes={subtypes} theme={theme} />
              <List.Item onClick={this.handleFilter}>
                <List.Icon name="undo" size="large" />
                <List.Content>
                  <List.Header>All Signs</List.Header>
                </List.Content>
              </List.Item>
            </List>
          </Segment>
        </Segment.Group>
      )
    }
    return null
  }
}

SubTypeMenu.propTypes = {
  subtypes: array.isRequired,
  theme: string.isRequired,
  showSubTypeMenu: bool.isRequired,
}

const mapStateToProps = ({ ui, spi }) => ({
  subtypes: zip(ui.chartData.labels, ui.chartData.datasets[0].backgroundColor),
  theme: spi.theme,
  showSubTypeMenu: ui.showSubTypeMenu,
})

const mapDispatchToProps = dispatch => ({
  toggleSubTypeMenu: value => dispatch(toggleSubTypeMenu(value)),
  filterSignsBySub: value => dispatch(filterSignsBySub(value)),
  updateClusterColor: value => dispatch(updateClusterColor(value)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SubTypeMenu)



// WEBPACK FOOTER //
// ./src/components/Elements/SearchContent/SubTypeMenu/index.jsx